import { observer } from 'mobx-react';
import { FC } from 'react';
import branchEditStore from '../../store/branchEditStore';
import { localeStore } from 'src/mobx/localesStore';
import client from 'src/services/client';
import wms from 'src/services/wms';
import { booleanToNumber, downloadFile, extractFileName } from 'src/utils/helpers';
import Text, { TEXT } from 'src/view/components/Text/Text';
import './style.scss';
import logger from '~/services/logger';

const QrCode: FC = observer((): JSX.Element => {
  const onPressDownloadQrCode = async () => {
    try {
      const { data, headers } = await client.get(
        `v4/branches/${String(branchEditStore.editableBranch.id)}/qr/pdf`,
        { params: { file: booleanToNumber(!window.IS_MOBILE) }, responseType: window.IS_MOBILE ? 'text' : 'blob' },
        true
      );

      if (window.IS_MOBILE) {
        wms.downloadFile(data);
      } else {
        downloadFile(data, extractFileName(headers));
      }
    } catch (error: any) {
      logger.error({ error, place: 'QrCode onPressDownloadQrCode' });
    }
  };

  return (
    <div className="w-25">
      <Text type={TEXT.SECTION_HEADER} text="qr_code_for_branch" />

      <img src={branchEditStore.editableBranch.emenu?.qr?.png} alt="branch_qr" className="branch-qr__img" />

      <p className="branch-qr__download-link" onClick={onPressDownloadQrCode}>
        {localeStore.t('download_branch_qr_code_button')}
      </p>
    </div>
  );
});

export default QrCode;
